export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/provider-logistics.d8bf3015-e07c88.svg";